import router from '@/router'
import { AppSidebar, AppHeader } from '@/components'
import FooterOutgoingLinks from '@/components/FooterOutgoingLinks.vue'

export const routes = [
  {
    path: '/profile',
    name: 'profile',
    components: {
      default: () => import('./profile.vue'),
      sidebar: AppSidebar,
      header: AppHeader,
      footer: FooterOutgoingLinks
    },
    meta: {
      sitemap: {
        title: 'My profile',
        description: "Manage user's account settings"
      },
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    }
  },
  {
    path: '/profile/personal-info',
    redirect: { name: 'profile' }
  },
  {
    path: '/profile/password',
    redirect: { name: 'profile' }
  },
  {
    path: '/profile/settings',
    redirect: { name: 'profile' }
  }
]

export default () => {
  routes.forEach(route => router.addRoute(route))
}
